import React from "react"
import styled from "styled-components"

const NormalWrapper = styled.g`
  .st2 {
    fill: none;
    stroke: #fff;
    stroke-width: 3;
  }
  .st4 {
    stroke: #000;
    stroke-width: 2;
  }
  .st4,
  .st5 {
    fill: none;
  }
  .st5,
  .st6,
  .st7 {
    stroke: #000;
  }
  .st7 {
    fill: none;
    stroke: #fff;
    stroke-width: 5;
  }
`

const NormalIcon = () => (
  <NormalWrapper className="mode-icon-wrapper">
    <circle className="icon-bg" cx="150" cy="150" r="150" />

    <g id="nornal-icon-body">
      <g id="nornal-icon-base">
        <path
          d="M105.72 267.28c33.16 2.02 66.32 2.02 99.48 0 2.33 0 4.22-1.89 4.22-4.22 3.89-9.21-101.51-2.11-103.69-4.22-5.45-.07-5.5 8.52-.01 8.44z"
          className="st2"
        />
        <path
          d="M96.45 258.85c37.66 1.72 75.31 1.72 112.97 0 5.78-.03 5.78-14.02 0-14.05 0 0-7.59 7.31-57.33 6.46-56.36 1.12-56.37-13.81-59.86-.61-.39 3.32.86 8.34 4.22 8.2z"
          className="st2"
        />
      </g>
      <g>
        <g>
          <path
            fill="#fff"
            stroke="#fff"
            d="M105.54 249c13.66-.8 108.66 8.48 107.91-6.74l-3.99-33.54-11.19-35.6c0-3.72-3.02-6.74-6.74-6.74H122.4c-3.72 0-6.74 3.02-6.74 6.74l-11.8 34.57-5.06 34.57c-.01 3.72 3.01 6.74 6.74 6.74z"
          />
        </g>
        <g>
          <path
            d="M138.56 232.05c1.77-2.38 5.37 6.82 26.51 1.01s23.84-16.27 25.52-15.3c6.36 19.16-19.27 27.24-36.2 21-5.88-2.12-17.11-4.99-15.83-6.71z"
            className="st4"
          />
        </g>
        <g>
          <path
            d="M133.93 211.03c-1.33 13.07 15.76 14.61 16.79 1.52 1.34-13.07-15.76-14.62-16.79-1.52zM167.52 211.62c-1.33 13.07 15.76 14.61 16.79 1.52 1.34-13.06-15.76-14.61-16.79-1.52z"
            className="st5"
          />
          <path
            d="M146.45 213.92c-.41 5.45-8.97 4.68-8.4-.76.21-2.32-3.96-8.69-3.96-8.69s12.57 7.13 12.36 9.45zM180.19 212.22c-.41 5.45-8.97 4.68-8.4-.76.21-2.32 4.58-11.13 4.58-11.13s4.03 9.58 3.82 11.89z"
            className="st6"
            fill="black"
          />
        </g>
        <g>
          <path
            d="M131.2 198.31c.73.81 1.46 1.63 2.19 2.44M142.11 194.68c.07 1.14.15 2.28.22 3.41M153.16 200.8l-1.71 2.43M164.34 202.2c1.21.32 2.28 1.14 2.91 2.23M173.83 196.14c.16 1.14.33 2.28.49 3.41M186.52 201.5c-.81.65-1.63 1.3-2.44 1.95"
            className="st5"
          />
        </g>
        <g>
          <path
            d="M170.61 182.49c4.45 6.28 11.83 10.38 19.51 10.86M139.85 180.47c-2.86 7.22-8.53 13.29-15.54 16.62"
            className="st4"
          />
        </g>
      </g>
      <path
        d="M115.84 166.9c13.1.64 79.45 5.26 82.62-3.5 0-1.94-2.27-3.51-5.06-3.51-26.12 1.08-51.98 1.1-77.56 0-6.54-.07-6.58 7.08 0 7.01z"
        className="st2"
      />
      <g>
        <g>
          <path
            d="M125.95 150.54c-7.84-12.24-20.82-49.55-21.92-64.28M103.19 86.26h21.08M105.47 98.06h10.37M109.14 107.41h10.37M112.36 116.76h8.43M116.03 126.11h10.37M119.11 133.12h6.74M122.77 142.47h15.18M126.94 150.65h10.37"
            className="st2"
          />
        </g>
        <path
          d="M115.84 159.89l77.56 1.17c16.46-31.9 26.75-63.84 28.66-95.83 0 2.53-123.09 2.34-138.26 0-15.18-1.17 6.83 9.48 7.37 15.1 1.82 18.93 15.23 58.73 24.67 79.56z"
          className="st2"
        />
        <path
          d="M235.92 134.18c13.27-28.63 47.43-90.73-10.78-74.4l-5.06 4.67s1.11 7.44 1.69 9.36c37.39-31.96 11.55 53.34-1.69 59.2-2.47 1.1-14.09 2.23-14.87 3.36-1.88 2.72-4.16 9.5-4.16 9.5 6.41-8.73 23.27-3.66 34.87-11.69z"
          className="st2"
        />
      </g>
      <g>
        <path
          d="M54.95 112.29l-5.31-28.57c-.54-5.41-3.12-5.73-5.85-3.29-10.07 3.25-1.29 27.18 1.04 33.74.44 2.34 3.05 3.81 5.85 3.29 3.7 2.02 5.45-.75 4.27-5.17z"
          className="st2"
        />
        <path
          d="M49.75 47.94c-9.68.33 9.05 102.23 18.53 99.62 18.36 37.79-8.74-123.61-18.53-99.62z"
          className="st2"
        />
      </g>
      <g>
        <path
          d="M209.17 210.67c9.42 6.86 18.35 14.38 26.72 22.48-6.72 4.85-15.21 9.69-21.94 14.54 2.08 3.16 6.51 4.05 6.51 4.05M116.72 203.73C87.42 189.64 50.4 176.21 20 173.34c3.55.33 19.51-31.6 23.59-56.88-.72-2.17-1.75-4.4-3.18-6.65"
          className="st7"
        />
      </g>
    </g>
  </NormalWrapper>
)

export default NormalIcon
/*

*/
